<template lang="pug">
  div(v-if="eventOne")
    portal(to="pageTitle")
      span Редактировать мероприятие

    v-container
      Settings(
        :languages="languages"
        :locale="locale"

        @languageChanged="onLanguageChanged"
      )

      .mt-10

      Content(
        :date="date.substr(0, 10)"
        :name="name"
        :code="code"
        @dateChanged="onDateChanged"
        @nameChanged="onNameChanged"
        @codeChanged="onCodeChanged"
      )

      .mt-10

      Controls(
        hasDelete
        @save="onSave"
        @delete="onDelete"
      )

</template>

<script>
import Controls from '../../components/widgets/PostControls'
import notify from '../../mixins/notify'

import Settings from './components/Settings'
import Content from './components/Content'
import Mixin from './components/Mixin.js'

import GetGQL from '../../graphql/private/Event/Get.gql'
import UpdateGQL from '../../graphql/private/Event/Update.gql'
import RemoveGQL from '../../graphql/private/Event/Remove.gql'

export default {
  name: 'events__id',
  components: {
    Settings,
    Content,
    Controls,
  },
  mixins: [Mixin, notify],
  data() {
    return {
      routeId: this.$route.params.id,
    }
  },

  apollo: {
    eventOne: {
      query: GetGQL,
      variables() {
        return {
          filter: {
            id: this.routeId,
            locale: this.locale,
          },
        }
      },
    },
  },
  methods: {
    async onSave() {
      const day = new Date(this.date)
      try {
        await this.$apollo.mutate({
          mutation: UpdateGQL,
          variables: {
            input: {
              id: this.id,
              active: true,
              locale: this.locale,
              name: this.name,
              date: day.toISOString(),
              code: this.code,
            },
          },
        })

        await this.$apollo.queries.eventOne.refetch()
        this.imageFile = null

        this.notify({
          text: 'Мероприятие обновлено!',
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
    },

    async onDelete() {
      try {
        await this.$apollo.mutate({
          mutation: RemoveGQL,
          variables: {
            id: this.routeId,
          },
        })

        this.notify({
          text: 'Мероприятие удалено!',
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
      await this.$router.push({
        name: 'events__list',
      })
    },
  },

  watch: {
    eventOne(event) {
      if (!event) {
        this.$router.push({
          name: 'events__list',
        })
      }
      const pst = {
        ...event,
      }
      for (const field in pst) {
        this[field] = pst[field]
      }
    },
  },
}
</script>
